export default __webpack_public_path__ + "locales/si/Settings.json?hash=f40872cc4d9c65f166fe4136daf79f0e";